import { render, staticRenderFns } from "./ConfigSimulacion.vue?vue&type=template&id=caca2c08&scoped=true&"
import script from "./ConfigSimulacion.vue?vue&type=script&lang=js&"
export * from "./ConfigSimulacion.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSimulacion.vue?vue&type=style&index=0&id=caca2c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caca2c08",
  null
  
)

export default component.exports